import fetch from "lib/fetch"
import { isSessionActive } from "lib/currentUser/session"
import { Mutex } from "async-mutex"

const CURRENT_USER_INFO_PATH = "/users/current.json"

// The topbar needs the page's admin actions and the news counts, and the response is cached for the page view.
const currentUserUrl = () =>
  `${CURRENT_USER_INFO_PATH}?path=${encodeURIComponent(window.location.pathname)}&include=counts`

class Cache {
  static currentUser() {
    Cache.fetchMutex ||= new Mutex()

    return Cache.fetchMutex.runExclusive(() => {
      if (Cache.currentUserValue != undefined) {
        return Promise.resolve(Cache.currentUserValue)
      }

      return fetch(currentUserUrl())
        .then((data) => data.json())
        .then((user) => {
          Cache.currentUserValue = user
          return user
        })
    })
  }
}

/**
 * Promise to fetch the current user.
 *
 * @returns {Promise}
 */
export function currentUser() {
  if (!isSessionActive()) {
    return Promise.resolve({})
  }

  return Cache.currentUser()
}
